//
//
//


import VAnchor from '~/components/v/anchor.vue'

export default {
  name: 'SetSorting',
  components: { VAnchor },
  props: {
    sortOptionsDsSource: {
      type: Array,
      default: []
    },
    sortBy: {
      type: String,
      default: '-premium_boat'
    }
  },
  data () {
    return {
      loading: true,
      items: [],
      hiddenItems: [],
      hiddenItemsIds: [],
      dropdown: false,
      interval: null
    }
  },
  computed: {
    getActiveSort () {
      return this.$Search.getAttributeValue('sortBy') || this.$Search.getDefaultAttributeValue('sortBy')
    },
    getSortItems () {
      return this.sortOptionsDsSource.map((i) => {
        return {
          title: i.localeTitle,
          key: i.id,
          route: this.$Search.getFilterUrl('sortBy', i?.route?.query?.sortBy ?? i.id)
        }
      })
    }
  },
  mounted () {
    this.loading = false
    this.sortItems()
    window.addEventListener('resize', this.sortItems)
  },
  methods: {
    close () {
      this.dropdown = false
    },
    async sortItems () {
      if (this.interval) {
        clearInterval(this.interval)
      }
      if (!process.client || this.loading) {
        return []
      }
      await this.$nextTick()
      this.items.splice(0)
      this.hiddenItems.splice(0)
      this.hiddenItemsIds.splice(0)
      await this.$nextTick()
      if (this.$refs.sorting) {
        const sortWidth = this.$refs.sorting.clientWidth
        let i = 0
        this.interval = setInterval(async () => {
          let totalWidth = 0
          await this.$nextTick()
          if (this.$refs.sortOption) {
            this.$refs.sortOption.forEach((sel) => {
              totalWidth += sel.clientWidth + 60
            })
          }

          if (totalWidth < sortWidth) {
            this.items.push(this.sortOptionsDsSource[i])
          } else {
            this.hiddenItems.push(this.sortOptionsDsSource[i])
            this.hiddenItemsIds.push(this.sortOptionsDsSource[i].id)
          }
          i++
          if (!this.sortOptionsDsSource[i] || i > 9) {
            clearInterval(this.interval)
          }
        }, 20)
      }
    }
  }
}
